import sanitize from "sanitize-html";
var vSanitizeHtml = {
  mounted: function(el, binding) {
    var saveHtml = sanitize(binding.value.html, binding.value.options);
    el.innerHTML = saveHtml;
  },
  updated: function(el, binding) {
    var saveHtml = sanitize(binding.value.html, binding.value.options);
    el.innerHTML = saveHtml;
  }
};
export { vSanitizeHtml };
